import React, { useState } from "react";
import {
    Row,
    Col,
    Button,
    FormGroup,
    Modal,
    ModalBody,
} from "reactstrap";
import { authenticationService } from '_services';
import { handleResponse } from '_helpers';
import Datetime from 'react-datetime';
import TSText from "components/Forms/TSText.js";
import TSSelect from "components/Forms/TSSelect.js";
var moment = require('moment');
require('moment/locale/th');
//function Register() {
const TSListAdmin2 = (props) => {

    const [errMsg, setErrMsg] = useState(false);
    const [modalError, setModalError] = useState(false);

    const [flow, setFlow] = useState('');
    const [serviceType, setServiceType] = useState('');
    const [titleOption, setTitleOption] = useState([]);
    const [serviceTypeOption, setServiceTypeOption] = useState([]);

    const [modalMsg, setModalMsg] = useState(false);
    const [modalLine, setModalLine] = useState(false);

    const [renderItem, setRenderItem] = useState([]);
    const [AppointDatetime, setAppointDatetime] = useState(moment().format('YYYY-MM-DD'));
    const [Keyword, setKeyword] = useState("");
    const [TeleID, setTeleID] = useState(null);
    const [value, setValue] = useState(moment().format('YYYY-MM-DD'));
    const [icon, setIcon] = useState("far fa-question-circle");


    React.useEffect(() => {
        const currentUser = authenticationService.currentUserValue;

        if (currentUser) {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json-patch+json',
                    'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                }
            };

            fetch('/api/v1/tele' + ((AppointDatetime != null) ? '?AppointDatetime=' + AppointDatetime : ''), requestOptions)
                .then(handleResponse)
                .then(
                    (result) => {
                        setRenderItem(result.data);
                    },
                    (error) => {
                        //alert(error);
                    }
            )

            /*
            setInterval(() => {
                if (Keyword.length > 2) {
                    var url = '/api/v1/tele?Keyword=' + Keyword + '&FlowStatus=' + flow + '&AppointDatetime=' + AppointDatetime;
                    retriveData(url);
                }
                else if (Keyword == '') {
                    var url = '/api/v1/tele?FlowStatus=' + flow + '&AppointDatetime=' + AppointDatetime;
                    retriveData(url);
                }
                
                //if (Keyword.length > 2) {
                //    var url = '/api/v1/tele?Keyword=' + Keyword + ((flow != '') ? '&FlowStatus=' + flow : '') + ((AppointDatetime != null) ? '&AppointDatetime=' + AppointDatetime : '');
                //    retriveData(url);
                //}
                //else if (Keyword == '') {
                //    var url = '/api/v1/tele?' + ((flow != '') ? '&FlowStatus=' + flow : '') + ((AppointDatetime != null) ? '&AppointDatetime=' + AppointDatetime : '');
               //     retriveData(url);
                //}
                

            }, 30000);
            */
        }

        fetch("/api/flow"/*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/)
            .then(response => response.json())
            .then((result) => { setTitleOption(result.data) }, (error) => { console.log(error) })

        fetch("/api/servicetype"/*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/)
            .then(response => response.json())
            .then((result) => { setServiceTypeOption(result.data) }, (error) => { console.log(error) })


        document.body.classList.add("landing-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("landing-page");
            document.body.classList.remove("sidebar-collapse");
        };

    },[]);

    const setDate = (e) => {
        setAppointDatetime(e);
        setValue(e)


        if (e != null && e != '') {
            var url = '/api/v1/tele?AppointDatetime=' + e + ((serviceType != null) ? '&ServiceType=' + serviceType : '') + ((flow != null) ? '&FlowStatus=' + flow : '') + ((Keyword.length > 2) ? '&Keyword=' + Keyword : '');
            retriveData(url);
        }
        else {
            var url = '/api/v1/tele' + ((serviceType != null) ? '?ServiceType=' + serviceType : '') + ((flow != null) ? '&FlowStatus=' + flow : '') + ((Keyword.length > 2) ? '&Keyword=' + Keyword : '');
            retriveData(url);
        }
    }

    const setStatus = (e) => {
        setFlow(e);

        //var url = '/api/v1/tele?FlowStatus=' + e + '&AppointDatetime=' + AppointDatetime
        //retriveData(url);
        
        if (e != null && e != '') {
            var url = '/api/v1/tele?FlowStatus=' + e + ((serviceType != null) ? '&ServiceType=' + serviceType : '') + ((AppointDatetime != null) ? '&AppointDatetime=' + AppointDatetime : '') + ((Keyword.length > 2) ? '&Keyword=' + Keyword : '');
            retriveData(url);
        }
        else {
            var url = '/api/v1/tele' + ((serviceType != null) ? '?ServiceType=' + serviceType : '') + ((AppointDatetime != null) ? '&AppointDatetime=' + AppointDatetime : '') + ((Keyword.length > 2) ? '&Keyword=' + Keyword : '');
            retriveData(url);
        }
        
    }

    const handleServiceType = (e) => {
        setServiceType(e);

        if (e != null && e != '') {
            var url = '/api/v1/tele?ServiceType=' + e + ((AppointDatetime != null) ? '&AppointDatetime=' + AppointDatetime : '') + ((flow != null) ? '&FlowStatus=' + flow : '') + ((Keyword.length > 2) ? '&Keyword=' + Keyword : '');
            retriveData(url);
        }
        else {
            var url = '/api/v1/tele' + ((AppointDatetime != null) ? '?AppointDatetime=' + AppointDatetime : '') + ((flow != null) ? '&FlowStatus=' + flow : '') + ((Keyword.length > 2) ? '&Keyword=' + Keyword : '');
            retriveData(url);
        }

    }

    const searchKeyword = (e) => {
        setKeyword(e);

        if (e.length > 2) {
            var url = '/api/v1/tele?Keyword=' + e + ((serviceType != null) ? '&ServiceType=' + serviceType : '') + ((flow != null) ? '&FlowStatus=' + flow : '') + ((AppointDatetime != null) ? '&AppointDatetime=' + AppointDatetime : '');
            retriveData(url);
        }
        else if (e == '') {
            var url = '/api/v1/tele' + ((serviceType != null) ? '?ServiceType=' + serviceType : '') + ((flow != null) ? '&FlowStatus=' + flow : '') + ((AppointDatetime != null) ? '&AppointDatetime=' + AppointDatetime : '');
            retriveData(url);
        }
    };

    const retriveData = url => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            }
        };

        fetch(url, requestOptions)
            //.then(response => response.json())
            .then(handleResponse)
            .then(
                (result) => {
                    setRenderItem(result.data);

                },
                (error) => {
                    setRenderItem([]);
                }
            )
    };



    const handleLine = e => {
       
        if (e.target.getAttribute('teleid') != null) {
            const teleid = e.target.getAttribute('teleid');
            const fullname = e.target.getAttribute('fullname');
            const phone = e.target.getAttribute('phone');
            const lineid = e.target.getAttribute('lineid');

            setTeleID(e.target.getAttribute('teleid'));
            setModalMsg('ยืนยันการเรียก\r\nคุณ ' + e.target.getAttribute('fullname') + ' \r\nเพื่อให้บริการ');
            setModalLine(true);
            /*
            console.log(teleid);
            console.log(fullname);
            console.log(phone);
            console.log(teleid);
            */ 
        }
       
    };
    const handleHN = e => {
        if (e.target.getAttribute('userID') != null) {
            const userID = e.target.getAttribute('userID');
            window.location.href = "/user/" + userID;
        }

    };

    const handleLineCall = (evt) => {
        if (TeleID != null) {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json-patch+json',
                    'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                }
            };

            fetch('/api/v1/tele/call/' + TeleID, requestOptions)
                .then(handleResponse)
                .then(
                    (result) => {
                        console.log(result);
                        window.alert("แจ้งเตือนเรียบร้อยแล้ว");
                        setModalLine(false);

                        var url = '/api/v1/tele?AppointDatetime=' + AppointDatetime
                        retriveData(url);

                        window.open('/vdoadmin/' + TeleID, 'Data', 'fullscreen=yes');
                    },
                    (error) => {
                        //alert(error);
                    }
                )
        }      
    };

    const handleCallNew = (evt) => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            }
        };

        fetch('/api/v1/tele/call2/' + TeleID, requestOptions)
            .then(handleResponse)
            .then(
                (result) => {
                    console.log(result);
                    window.alert("แจ้งเตือนเรียบร้อยแล้ว");
                    setModalLine(false);

                    //window.open('/admincall/' + TeleID, 'Data', 'fullscreen=yes');
                    window.open('https://meet.trangskin.go.th/' + TeleID, 'Data', 'fullscreen=yes');
                },
                (error) => {
                    //alert(error);
                }
            )
    };

  /*

    handleChange = event => {
        setValue(event.target.value);

        if (this.props.onChange)
            this.props.onChange(event);
    };

    setKeyword(e) {
        this.setState(state => ({
            Keyword: e
        }));
    }


    const handleConfirm = (evt) => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

        var birthdate = moment([bYear, bMonth - 1, bDay]);

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
            },
            body: JSON.stringify({
                "username": Username,
                "password": Password,
                "email": Email,
                "lineTrangskin": LineTrangskin,
                "firstName": FirstName,
                "lastName": LastName,
                "idCard": CID,
                "phone": phone,
                "birthDate": birthdate.format('YYYY-MM-DD')
            })
        };

        fetch('/api/v1/identity/web-register', requestOptions)
            .then(response => response.json())
            .then(
                (result) => {


                    if (liff.isInClient()) {

                        liff.sendMessages([{
                            'type': 'text',
                            'text': '#registered'
                        }]).then(function () {
                            //window.alert('Message sent');
                            liff.closeWindow();
                        }).catch(function (error) {
                            window.alert('Error sending message: ' + error);
                        });

                    } else {
                        authenticationService.login(Username, Password)
                            .then(
                                user => {
                                    const { from } = props.location.state || { from: { pathname: "/profile" } };
                                    props.history.push(from);
                                },
                                error => {

                                    if (result.errors !== "undefined") {
                                        try {

                                            setModal2(false);
                                            setIcon("far fa-question-circle");
                                            setErrMsg(result.errors[0]);
                                            setModalError(true);

                                        }
                                        catch (e) { console.log(e) }
                                    }

                                }
                            );
                    }

                },
                (error) => {
                    alert(error);
                }
            )
    }
*/

    const content = renderItem.map((post, index) =>
        <Row key={index} style={{ fontSize: '1em', padding: '10px 10px', borderBottom: '1px solid #dddddd' }}>
            <Col md="2" xs="6">
                <a href={"/teleInfo/" + post.teleID} > {post.fullName} </a>
            </Col>
            <Col md="2" xs="6">
                {post.appointDatetimeText}
            </Col>
            <Col md="2" xs="6">
                {post.serviceTypeName}
            </Col>
            <Col md="2" xs="6">
                {post.flowStatusName}
            </Col>
            <Col md="4" xs="12">
                {
                    (post.hn == null) ?
                        <Button color="gray" size="sm" val="1"
                            userID={post.userID}
                            onClick={handleHN}>
                        <i className="fas fa-user-plus" style={{ fontSize: '1.2em', color: 'white' }}></i> สร้างHN
                        </Button>
                        : ""

                }


                {
                (post.flowStatus == 1) ?
                            <Button color="success" size="sm" val="1"
                    teleid={post.teleID}
                    fullname={post.fullName}
                    phone={post.phone}
                    lineid={post.lineID}
                    onClick={handleLine}>
                    <i className="fab fa-line" style={{ fontSize: '1.2em', color: 'white' }}></i> เรียก
                            </Button>
                            : ""
                }

                {
                    (post.hn != null) ?
                        <Button color={(post.flowStatus > 1) ? "success" : "primary"} size="sm" val="1"><i className="fas fa-user-nurse"></i> ซักประวัติ </Button>
                        :
                        ""
                }

                {
                    (post.hn != null) ?
                        <Button color={(post.flowStatus == -3 || post.flowStatus > 2) ? "success" : "primary"} size="sm" val="1"><i className="fas fa-user-md"></i> พบแพทย์ </Button>
                        :
                        ""
                }

                {
                    (post.hn != null) ?
                        <Button color={(post.flowStatus >= 3) ? "success" : "primary"} size="sm"><i className="fas fa-money-bill-wave"></i> แจ้งยอด</Button>
                        :
                        ""
                }

                {
                    (post.hn != null) ?
                        <Button color={(post.flowStatus > 4) ? "success" : "primary"} size="sm"><i className="fas fa-money-bill-wave"></i> {(post.flowStatus > 4) ? "ชำระแล้ว" : "ยังไม่ชำระ"} </Button>
                        :
                        ""
                }


                {
                    (post.hn != null) ?
                        <Button color={(post.flowStatus > 5) ? "success" : "primary"} size="sm"> <i className="fas fa-ambulance"></i> จัดส่ง </Button>
                        :
                        ""
                }
                {
                    (post.hn != null) ?
                        <Button color={(post.flowStatus > 6) ? "success" : "primary"} size="sm"> <i className="fas fa-box-open"></i> รับยาแล้ว </Button>
                        :
                        ""
                }

            

                

               
            </Col>
        </Row>
    );



    var renderers = {
        renderDay: function (props, currentDate, selectedDate) {
            return <td {...props}>{currentDate.date()}</td>;
        },
        renderMonth: function (props, month, year, selectedDate) {
            return <td {...props}>{month}</td>;
        },
        renderYear: function (props, year, selectedDate) {
            return <td {...props}>{year}</td>;
        }
    }



    return (
        <>
            <div /*style={{ backgroundColor: '#2ca8ff1f' }}*/>

                <Row>
                    <Col className="text-left" xs="4" style={{ marginTop: -20 }}>
                        <TSText fontSize={"1em"} name="Keyword" placeholder="ค้นหา" onChange={e => searchKeyword(e.target.value)} icon="tech_mobile" />
                    </Col>
                    <Col className="text-right" xs="4">
                        <FormGroup
                            style={{ padding: '0 0px', marginBottom: '10px' }}
                            className="input-lg"
                        >
                            <i className="now-ui-icons ui-1_calendar-60" style={{
                                position: 'absolute',
                                left: '18px',
                                top: '18px',
                                zIndex: 1,
                                fontSize: '1rem'
                            }}
                            ></i>
                            <Datetime
                                renderDay={renderers.renderDay}
                                renderYear={renderers.renderYear}
                                isValidDate={e => e.day() !== 0 && e.day() !== 6}
                                inputProps={{ name: "AppointDatetime", placeholder: "วันที่รับบริการ", readOnly: 'readonly', style: { fontSize: '1.2em', paddingLeft: '50px', cursor: 'pointer' } }}
                                closeOnSelect={true}
                                closeOnTab={true}
                                dateFormat="DD MMMM YYYY" timeFormat={false}
                                onChange={e => setDate(e.format('YYYY-MM-DD HH:mm'))}
                                value={value}
                            />

                        </FormGroup>
                    </Col>

                    
                    <Col className="text-left" xs="1" >
                        <Button className="btn-icon btn-round" color="primary" onClick={e => setDate('')}>
                            <i className="fas fa-times"></i>
                        </Button>
                    </Col>
                    <Col xs="3" style={{ marginTop: -20}}>
                        สถานะ<TSSelect isDefault options={titleOption} onChange={e => setStatus(e)} value={flow} />
                    </Col>
                    {/*
                    <Col className="text-center ml-auto mr-auto" lg="6" sm="12">
                        <TSText name="Keyword" placeholder="ค้นหา ชื่อ, เลขบัตรประชาชน" onChange={e => this.setKeyword(e.target.value)} icon="tech_mobile" />
                    </Col>
                    */}
                </Row>

                <Row style={{ fontWeight: 'bold', fontSize: '1em', padding: '10px 10px', borderBottom: '2px solid #dddddd' }}>
                    <Col md="2" xs="6" className="d-none d-sm-block">
                        ชื่อ
                    </Col>
                    <Col md="2" xs="6" className="d-none d-sm-block">
                        วันที่นัด
                    </Col>
                    <Col md="2" xs="6" className="d-none d-sm-block">
                        ประเภท <TSSelect isDefault options={serviceTypeOption} fontSize={'1em'} height={'30px'} onChange={e => handleServiceType(e)} value={serviceType} />
                    </Col>
                    <Col md="2" xs="6" className="d-none d-sm-block">
                        สถานะ
                    </Col>
                    <Col md="4" xs="12" className="d-none d-sm-block">
                        จัดการ
                    </Col>
                </Row>
                {content}
            </div>
            <Modal
                modalClassName="modal-mini modal-info"
                toggle={() => setModalLine(false)}
                isOpen={modalLine}
            >
                <div className="modal-header justify-content-center">
                    <div className="modal-profile">
                        <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                    </div>
                </div>
                <ModalBody>

                    <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? modalMsg : "กำลังตรวจสอบข้อมูล"}</p>
                    <p>  </p>
                </ModalBody>
                <div className="modal-footer">
                    <Button
                        className="btn-neutral"
                        color="link"
                        type="button"
                        onClick={() => setModalLine(false)}
                    >
                        ยกเลิก
                                      </Button>

                    <Button
                        className="btn-neutral"
                        color="link"
                        type="button"
                        onClick={handleCallNew}
                        disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                    //onClick={() => setModal2(false)}
                    >
                        ยืนยัน
                                      </Button>



                </div>
            </Modal>
        </>
    );
}

export default TSListAdmin2;
